<template>
  <router-view/>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class OptimizerPro extends Vue {

}

</script>
